import(/* webpackMode: "eager" */ "/home/ubuntu/cal-ay/apps/web/app/global-error.tsx");
